import { useQuery } from '@tanstack/react-query';
import type { SkillLibraryEntry } from '../types';

export default function useSkillLibraryEntry(entryId: string | null) {
  return useQuery<SkillLibraryEntry>({
    queryKey: ['skill-library', entryId],
    enabled: entryId !== null,
  });
}
